import { debounce, throttle } from './utils/utils';

const blocks = document.querySelectorAll('.scroll-navigation-block');

if (blocks.length) {
  const hero = document.querySelector('#main > section');

  // heights
  const heroHeight = hero ? hero.offsetHeight : 0;
  const header = document.querySelector('#header');
  const spaceHeight = 32;
  const entries = document.querySelectorAll('section');

  // do this whenever the active element changes (scrolls the Navigation vertically to the active element )
  const scrollNav = (container, element, offset) => {
    const elementBoundingRect = element.getBoundingClientRect();
    const parentBoundingRect = container.getBoundingClientRect();

    //container bounds
    const left = parseInt(parentBoundingRect.left, 10);
    const right = parseInt(parentBoundingRect.right, 10);

    //nav-element bounds
    const elementLeft = parseInt(elementBoundingRect.left, 10);
    const elementRight = parseInt(elementBoundingRect.right, 10);

    // scroll
    let scrollBy = 0;
    if (elementLeft < left + offset) {
      scrollBy = elementLeft - left - offset;
    } else if (elementRight > right - offset) {
      scrollBy = elementRight - right + offset;
    }
    if (scrollBy !== 0) {
      container.scrollLeft += scrollBy;
    }
  };

  blocks.forEach(block => {
    const navContainer = block.querySelector('.scroll-nav');
    const navWrapper = navContainer.querySelector('.nav-wrapper');
    const navIndicator = navContainer.querySelector('.nav-indicator');
    const navLinks = navContainer.querySelectorAll('a:not(.keyboard-hidden)');
    const jumpToSectionLink = navContainer.querySelector('a.keyboard-hidden');

    const scrollNavHeight = document.querySelector('.scroll-navigation-block').offsetHeight;

    // record of all the sections and their links and their general properties
    const navigationSections = [];
    // datamodel for indicator
    let activeSection;

    const calcIndicator = link => {
      if (!link.classList.contains('active')) {
        return;
      }
      link.removeAttribute('style');
      navIndicator.style.transform = 'scale(1, 1)';
      navIndicator.style.width = `${link.offsetWidth}px`;
      navIndicator.style.left = `${link.offsetLeft}px`;
    };
    const removeIndicator = () => {
      navIndicator.style.width = `${navLinks[0].offsetWidth}px`;
      navIndicator.style.left = `${-1 * (navLinks[0].offsetWidth + 20)}px`;
    };

    const setActiveSection = section => {
      //if section and activesection are the same, no further action is needed (also when they are both falsy)
      if (!(section || activeSection) || section === activeSection) {
        return;
      }
      if (activeSection) {
        activeSection.link.classList.remove('active');
      }
      if (section) {
        section.link.classList.add('active');
        scrollNav(navContainer, section.link, 60);
        calcIndicator(section.link);
      } else {
        removeIndicator();
      }
      //set new activeSection reference
      activeSection = section;
    };

    if (block.classList.contains('mag-block')) {
      const skipBlocks = block.dataset.skipBlocks;
      let h2s = document.querySelectorAll('h2');
      if (skipBlocks) {
        const skipArray = skipBlocks.split(',');
        h2s = Array.from(h2s).filter((_, i) => skipArray.indexOf((i + 1).toString()) === -1);
      }
      navLinks.forEach((link, i) => {
        const section = h2s[i].closest('section');
        const scrollId = !section.id ? link.textContent.trim().replace(' ', '-').toLowerCase().slice(0, 6) + (i + 1) : section.id;
        link.href = '#' + scrollId;
        section.id = scrollId;
      });
    }

    // initialize Scroll Navigation
    navLinks.forEach(link => {
      let entry = document.querySelector(link.getAttribute('href'));
      if (!entry) {
        return;
      }
      if (entry.tagName !== 'SECTION') {
        entry = entry.closest('section');
      }
      const offset = entry.dataset.offset || 0;
      const compStyles = window.getComputedStyle(entry);
      const entryPadding = parseFloat(compStyles.getPropertyValue('padding-top'));

      // Only add back to scroll nav if mag toc is not given
      if (!document.querySelector('.mag-cont-toc')) {
        const container = entry.querySelector('.container');

        let containerRight = null;
        if (container) {
          const rect = container.getBoundingClientRect();
          containerRight = window.innerWidth - rect.right;
        }

        const backToScrollNavLink = document.createElement('a');
        backToScrollNavLink.href = '#';
        backToScrollNavLink.innerHTML =
          (window.en ? 'To the scroll navigation' : 'Zur Scroll-Navigation') +
          `<svg>
                <use xlink:href="/assets/dist/sprite.svg#btn-arrow"></use>
              </svg>`;
        backToScrollNavLink.classList.add('keyboard-hidden', 'back-to-scroll-nav', 'display--sm');

        // Add event listener
        backToScrollNavLink.addEventListener('click', ev => {
          ev.preventDefault();
          link.focus();
        });

        entry.prepend(backToScrollNavLink);

        backToScrollNavLink.style.right = container ? containerRight + 'px' : compStyles.paddingRight;

        if (entryPadding) {
          backToScrollNavLink.style.top = entryPadding / 2 - backToScrollNavLink.offsetHeight / 2 + 'px';
        } else {
          const entryMarginTop = parseFloat(compStyles.marginTop);
          const entryIndex = Array.from(entries).indexOf(entry);
          const prevEntry = entries[entryIndex - 1];
          entry.style.marginTop = entryMarginTop - 40 + 'px';
          entry.style.paddingTop = 40 + 'px';
          backToScrollNavLink.style.top = 0;
          if (prevEntry !== block) {
            prevEntry.style.marginBottom = parseInt(window.getComputedStyle(prevEntry).marginBottom) - 40 + 'px';
          }
        }
      }

      const sectionObject = {
        link,
        entry,
        offset,
        padding: entryPadding
      };
      navigationSections.push(sectionObject);
      if (link.classList.contains('active')) {
        activeSection = sectionObject;
      }

      link.addEventListener('click', ev => {
        ev.preventDefault();
        if (jumpToSectionLink) {
          jumpToSectionLink.classList.remove('disabled');
        }
      });
    });

    if (jumpToSectionLink) {
      jumpToSectionLink.addEventListener('click', ev => {
        ev.preventDefault();
        if (jumpToSectionLink.classList.contains('disabled')) {
          return;
        }
        let section;
        if (activeSection && activeSection.entry) {
          section = activeSection.entry;
        } else {
          const activeLink = navContainer.querySelector('a.active');
          if (!activeLink) {
            return;
          }
          section = document.querySelector(activeLink.getAttribute('href'));
        }
        const backToNavlink = section.querySelector('.back-to-scroll-nav');
        (backToNavlink ? backToNavlink : section.querySelector('a, button, input, select, [tabindex]:not([aria-hidden="true"])')).focus();
      });
    }

    //checks if a section is below the threshhold on a page
    const isBelowThreshhold = (section, threshhold) => {
      const rect = section.entry.getBoundingClientRect();
      return rect.top + section.padding > threshhold;
    };

    //checks which section should be the active one according to scroll position and update if appropriate
    //checks the last active section first and then goes up or down through the sections depending on the last active sections position
    const checkActiveSection = () => {
      const headerOffset = header ? header.offsetHeight : 0;
      const threshhold = (window.innerHeight - headerOffset) * 0.3 + headerOffset;
      if (window.scrollY < heroHeight - threshhold) {
        setActiveSection();
        return;
      }

      const startIndex = activeSection ? navigationSections.indexOf(activeSection) : 0;
      if (!isBelowThreshhold(navigationSections[startIndex], threshhold)) {
        for (let i = startIndex; i < navigationSections.length - 1; i++) {
          if (isBelowThreshhold(navigationSections[i + 1], threshhold)) {
            setActiveSection(navigationSections[i]);
            return;
          }
        }
        setActiveSection(navigationSections[navigationSections.length - 1]);
      } else {
        for (let i = startIndex - 1; i > 0; i--) {
          if (!isBelowThreshhold(navigationSections[i], threshhold)) {
            setActiveSection(navigationSections[i]);
            return;
          }
        }
        setActiveSection(navigationSections[0]);
      }
    };
    window.addEventListener('scroll', throttle(checkActiveSection, 150));

    //update paddings on resize and reset the active section
    window.addEventListener(
      'resize',
      debounce(() => {
        navigationSections.forEach(section => {
          section.padding = parseFloat(window.getComputedStyle(section.entry).getPropertyValue('padding-top'));
        });
        checkActiveSection();
      }, 300)
    );

    // horizotal scroll area on mobile
    const setNav = () => {
      const width = navWrapper.offsetWidth - navContainer.offsetWidth;
      const scrollPercent = width > 0 ? (100 * navContainer.scrollLeft) / width : 0;
      const left = scrollPercent < 2 ? 0 : 1;
      const right = scrollPercent > 98 || width <= 0 ? 0 : 1;
      block.querySelector('.scroll').style.setProperty('--left-opacity', left);
      block.querySelector('.scroll').style.setProperty('--right-opacity', right);
    };

    navContainer.addEventListener('scroll', throttle(setNav, 300, true, true));
    window.addEventListener('resize', debounce(setNav, 300));
    document.addEventListener('DOMContentLoaded', setNav);
    window.addEventListener('customLoaded', setNav);
  });
}
